import { useState, useEffect, useRef } from 'react'
import Box from '@mui/joy/Box'
import { TemplateEditor } from '../components/TemplateEditor.js'
import { useNavigate } from 'react-router-dom'
import { canvasActions } from '../common/canvasActions'
import { canvasUtils } from '../common/canvasUtils'
import { BlobAPI } from '../api/BlobAPI'
import { useParams } from 'react-router-dom'
import { TEMPLATE_EDITOR_FUNC_MAP } from '../common/utils'
import _ from 'lodash'

export const TemplateBuilder = () => {
    const [error, setError] = useState(null)
    const { templateType } = useParams()
    const funcMap = useRef(null)
    const navigate = useNavigate()

    useEffect(() => {
        if (!TEMPLATE_EDITOR_FUNC_MAP[templateType.toUpperCase()]) {
            throw new Error('Invalid Template Type')
        }
        funcMap.current = TEMPLATE_EDITOR_FUNC_MAP[templateType.toUpperCase()]
    }, [])

    const saveTemplate = (title, canvas) => {
        let screenshot = canvasActions.takeScreenshot(canvas)
        const blob = canvasUtils.dataUrlToBlob(screenshot)

        funcMap.current
            .submit(title, blob, JSON.stringify(canvas.toJSON()))
            .then((response) => {
                window.location.reload()
            })
            .catch((e) => {
                console.log(e)
            })
    }

    const handleSave = (title, canvas) => {
        if (!title) {
            setError('Please title the template')
            return
        }

        let result = funcMap.current.validate(canvas.toJSON())
        if (!result.isValid) {
            setError(result.reason)
            return
        }

        const newImages = canvasUtils.mapNewImages(canvas)
        if (_.isEmpty(newImages)) {
            saveTemplate(title, canvas)
            return
        }

        let urlsBody = Object.entries(newImages).map(([uid, file]) => {
            return { filename: file.name, mime_type: file.type }
        })

        BlobAPI.getPresignedUrlV2(urlsBody).then((response) => {
            let promises = []
            let presignMap = {}
            response.data.urls.forEach((presign) => {
                Object.entries(newImages).forEach(([uid, file]) => {
                    if (presign.filename === file.name) {
                        promises.push(BlobAPI.uploadBlob(presign.url, file))
                        presignMap[uid] =
                            `${presign.url.url}${presign.url.fields.key}`
                    }
                })
            })
            Promise.all(promises).then(() => {
                const swapPromises = canvasUtils
                    .getImages(canvas)
                    .map((img) => {
                        const newUrl = presignMap[img.id]
                        if (!newUrl) {
                            return null
                        }

                        return new Promise((resolve, reject) => {
                            img.set({ crossOrigin: 'anonymous' })
                            img.setSrc(
                                newUrl,
                                (img) => {
                                    if (!img._element) {
                                        return reject(
                                            new Error(
                                                `Failed to load ${newUrl}`
                                            )
                                        )
                                    }
                                    resolve()
                                },
                                { crossOrigin: 'anonymous' }
                            )
                        })
                    })
                    .filter(Boolean)

                Promise.all(swapPromises)
                    .then(() => {
                        saveTemplate(title, canvas)
                    })
                    .catch((e) => {
                        console.log(`could not save the template ${e}`)
                    })
            })
        })
    }

    return (
        <TemplateEditor
            onSave={handleSave}
            onExit={() => navigate('/merchant/template_library')}
            errorMsg={error}
        />
    )
}
